import {Preferences} from './preferences.js';
import {Person} from './person.js';
import {Names} from './names.js';
import {Addresses} from './addresses.js';
import {PhoneNumbers} from './phoneNumbers.js';
import {TermsAndConditions} from './termsAndConditions.js';
import {LegalID} from './legalId.js';

export var Account = function(accountData) {
    var account = {};
    var persons = [];
    
    // Constructor
    if (accountData) {
        account.id = accountData.id;
        account.recruiterID = accountData.recruiterID;
        account.country = accountData.country;
        account.email = accountData.email;
        account.setupDate = accountData.setupDate;
        account.sponsorID = accountData.sponsorID;
        account.preferredLanguage = accountData.preferredLanguage;
        account.beType = accountData.beType;
        account.accountType = accountData.accountType;
        account.temporary = accountData.temporary;
        account.deleted = accountData.deleted;
        account.signupReqMet = accountData.signupReqMet;
        account.origin = accountData.origin;
        account.title = accountData.title;
        account.profilePictureUrl = accountData.profilePictureUrl;
        account.profileThumbnailUrl = accountData.profileThumbnailUrl;

        account.preferences = Preferences(accountData.preferences);
        
        account.purchaseAgreementCountries = accountData.purchaseAgreementCountries;
        account.sponsorAgreementCountries = accountData.sponsorAgreementCountries;

        account.names = Names(accountData.names);
        account.addresses = Addresses(accountData.addresses);
        account.phoneNumbers = PhoneNumbers(accountData.phoneNumbers);
        account.termsAndConditions = TermsAndConditions(accountData.termsAndConditions);

        account.legalIDs = [];
        if (accountData.legalIDs) {
            for (var i=0; i<accountData.legalIDs.length; i++) {
                account.legalIDs.push(LegalID(accountData.legalIDs[i]));
            }
        }

        // For the US and CA we need to overwrite this using an atlas call.
        account.bankAccounts = accountData.bankAccounts; // This is a one to one match with the legacy call.
        
        account.persons = persons;

        // Load up the persons array
        if (accountData.persons.length > 0) {
            for (var i=0; i<accountData.persons.length; i++) {
                persons.push(Person(accountData.persons[i]));
            }
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    account.getPrimaryPerson = function() {
        var primaryPerson;

        for (var i = 0; i < persons.length; i++) {
            if (persons[i].type === 'PRIMARY') {
                primaryPerson = persons[i];
                break;
            }
        }

        // If there is no primary person, we just pick the first one on the account.
        if (!primaryPerson && persons.length > 0) {
            primaryPerson = persons[0];
        }

        return primaryPerson;
    };

    account.getAssociates = function() {
        var associates = [];

        for (var i = 0; i < persons.length; i++) {
            if (persons[i].type !== 'PRIMARY') {
                associates.push(persons[i]);
            }
        }

        return associates;
    };

    account.getPersonById = function(personId) {
        var person;

        for (var i = 0; i < persons.length; i++) {
            if (persons[i].id === personId) {
                person = persons[i];
                break;
            }
        }

        return person;
    };
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return account;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/account.js
// module id = 354
// module chunks = 0